const API_URL = process.env.REACT_APP_API_URL || 'https://api.cerebrorisk.com';
const API_KEY = 'af4d4829d5bfbc9353dd7371b05a3c69c8cbe10fb61c5b383963b22233cebab2';

export const api = {
  async getSubmissions(tenantId) {
    const res = await fetch(`${API_URL}/api/submissions?tenant_id=${tenantId}`, {
      headers: { 'x-api-key': API_KEY },
    });
    if (!res.ok) throw new Error('Failed to fetch submissions');
    return res.json();
  },

  async updateStatus(id, status, note = null) {
    const res = await fetch(`${API_URL}/api/submissions/${id}/status`, {
      method : 'PATCH',
      headers: { 'Content-Type': 'application/json', 'x-api-key': API_KEY },
      body   : JSON.stringify({ status, note }),
    });
    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.error || 'Failed to update status');
    }
    return res.json();
  },
};
